export function removeInvalidStyleAndAttr(node) {
  if (node == null) return;

  Object.entries(INVAILD_CSS_MAP).forEach(([cssPropName, cssPropValues]) => {
    const cssPropValue = node.style[cssPropName]
    const hasInvalidProp = cssPropValue != null;
    if (!hasInvalidProp) return;
    
    const hasInvalidValue = cssPropValues.length === 0 || cssPropValues.includes(cssPropValue);
    if (!hasInvalidValue) return;

    node.style.removeProperty(cssPropName);
  })

  Object.entries(INVAILD_ATTRIBUTE_MAP).forEach(([attrName, attrValues]) => {
    if (!node.getAttribute(attrName)) return;
    node.removeAttribute(attrName);
  })

  if (node.children.length === 0) return;
  Array.from(node.children).forEach((childNode) => removeInvalidStyleAndAttr(childNode));
}

const INVAILD_CSS_MAP: { [K in string]: (string | number)[] } = {
  display: ['none'],
  visibility: ['hidden'],
};

const INVAILD_ATTRIBUTE_MAP = {
  contenteditable: [],
};

export function checkStyleEdited(element){
  const result = element.classList.contains('stb-bold') || 
                 element.classList.contains('stb-italic') || 
                 element.classList.contains('stb-underline') || 
                 element.classList.contains('stb-line-through') || 
                 element.classList.contains('stb-fore-colored') || 
                 element.classList.contains('stb-hilitecolor-colored')
  return result
}